import { IdentityProvider } from "Api/Api";
import { AuthPageLayout } from "Components/Auth/Shared/AuthPageLayout";
import { AuthRedirectProgress } from "Components/Auth/Shared/AuthRedirectProgress";
import { StyledContainer } from "Components/Auth/Styles";
import { useNavigate } from "Navigation/useNavigate";
import { signInSsoAsync } from "State/Auth/SignIn/SignInSsoState";
import { Resources, useResource } from "Translations/Resources";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";

//Is this component even used?
export const GoogleRedirectPage = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useResource();

  const code = new URLSearchParams(location.search).get("code") || "";
  const anonymousLogin =
    new URLSearchParams(location.search).get("anonymousLogin") || "";

  React.useEffect(() => {
    const affiliateCode = getLocalStorageItem(LocalStorageKeys.AffiliateCode);

    dispatch(
      signInSsoAsync.request({
        model: {
          token: code,
          identityProvider: IdentityProvider.Google,
          affiliateCode,
          anonymousLogin,
        },
        navigate,
      }),
    );
  }, [code, anonymousLogin, dispatch, navigate]);

  return (
    <AuthPageLayout title={t(Resources.Auth.Redirecting)} pageType="other">
      <StyledContainer>
        <AuthRedirectProgress />
      </StyledContainer>
    </AuthPageLayout>
  );
};

export default GoogleRedirectPage;
